/**
 * WallBounce.js
 * Implements the little wall bounce animation
 */

import { Game, GameAnimatedSprite, GameScene } from "pixi_core";
import { GameEvents, SceneLayers } from "../Constants";

export class WallBounce {
    /**
     * @public
     * @param {GameScene} scene
     */
    constructor(scene) {
        /** @private @type {GameAnimatedSprite} */
        this._wallBounce = new GameAnimatedSprite(null, Game.design.getGraphicData("WallBounce"), scene, SceneLayers.eWALLS);
        this._wallBounce.visible = false;

        Game.on(GameEvents.eGAME_WALL_BOUNCE, this._onWallBounce, this);
    }

    /**
     * @private
     * @param {Object} options
     */
    _onWallBounce(options) {
        this._wallBounce.x = options.x;
        this._wallBounce.y = options.y;
        this._wallBounce.angle = options.angle < 0 ? 0 : 180;

        this._wallBounce.visible = true;

        this._wallBounce.playAnimation("bounce");

        this._wallBounce.onComplete = () => {
            this._wallBounce.visible = false;
        };
    }

    /**
     * @public
     */
    destroy() {
        if (this._wallBounce) {
            this._wallBounce.destroy();
            this._wallBounce = null;
        }

        Game.off(GameEvents.eGAME_WALL_BOUNCE, this._onWallBounce, this);
    }
}
